import { render, staticRenderFns } from "./upload-dragdown.vue?vue&type=template&id=42a74695"
import script from "./upload-dragdown.vue?vue&type=script&lang=js"
export * from "./upload-dragdown.vue?vue&type=script&lang=js"
import style0 from "./upload-dragdown.vue?vue&type=style&index=0&id=42a74695&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports